<template>
    <div class="bg_eef1fa video web_detail">
        <div class="main flex_space_between">
            <div class="left">
                <div class="video_main">
                    <video
                        ref="myVideo"
                        :poster="detail.pic"
                        :src="detail.annex"
                        controls
                        oncontextmenu="return false;"
                        controlslist="nodownload"
                        class="video-box"
                    ></video>
                    <div class="video_operate flex_start align_items_center">
                        <p class="flex_start align_items_center" @click="goodBtn(detail.id)">
                            <img src="@/assets/images/good.png" v-if="is_good == 0" />
                            <img src="@/assets/images/good_red.png" v-else />
                            <span>点赞</span>
                        </p>
                        <p class="flex_start align_items_center" @click="likeBtn(detail.id)" >
                            <img src="@/assets/images/collect.png" v-if="is_like == 0"/>
                            <img src="@/assets/images/collect_red.png" v-else/>
                            <span>收藏</span>
                        </p>
                        <!--<p class="flex_start align_items_center">
                            <img src="@/assets/images/share.png" />
                            <span>分享</span>
                        </p>-->
                        <div class="video_operate_see">{{detail.click}}次播放</div>
                    </div>
                </div>

                <div class="content flex_start align_items_flex_start">
                    <img :src="detail.pic" />
                    <div class="content_info">
                        <h2>{{detail.title}}</h2>
                        <h3>
                            <i>简介：</i>{{detail.intro}}
                        </h3>
                        <p class="flex_start flex_wrap">
                            <span v-for="(item,index) in detail.flag">{{item}}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="right">
                <h3>相关推荐</h3>
                <div class="like_list flex_start" v-for="(item,index) in likelist" v-if="index <= 4" @click="goUrl(this,item.id,item.type)">
                    <div class="like_list_img">
                        <img :src="item.pic" />
                    </div>
                    <div class="like_list_text">
                        <h2>{{item.title}}</h2>
                        <p class="flex_start">
                            <span>{{item.click}}播放</span>
                            <span>{{item.good}}点赞</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "detail",
        data(){
            return {
                id: 0,
                detail:[],
                likelist: [],
                is_like: 0,
                is_good: 0
            }
        },

        created() {
            this.id = this.$route.query.id;
            this.$http({
                url: 'index/article',
                method: 'post',
                headers: {"Content-Type": "multipart/form-data"},
                data:{type:'video',id:this.id,token: localStorage.getItem('user_token')}
            }).then(res => {
                if(res.data.code == 1) {
                    this.detail = res.data.data.detail;
                    this.likelist = res.data.data.like;
                    this.is_like = res.data.data.is_like;
                    this.is_good = res.data.data.is_good;
                } else {
                    layer.msg(res.data.msg);
                }
            });
        },
        watch: {
            $route() {
                location.reload();
            },
        },
        mounted() {
        },
        methods: {
            goUrl: function (obj,id,type) {
                this.$router.push({
                    path: '/' + type + '/detail',
                    query: {
                        id: id
                    }
                })
            },
            likeBtn: function (id) {
                let _this = this;
                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/likeBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        _this.is_like = _this.is_like == 1 ? 0 : 1;
                    }
                    layer.msg(res.data.msg);
                });
            },
            goodBtn: function (id) {
                let _this = this;
                if(!localStorage.getItem('user_id'))
                {
                    layer.msg('请先登录，正在为您跳转，请稍后。。。');
                    setTimeout(function () {
                        _this.$router.push({
                            path: '/my/login'
                        })
                    },1500);
                    return false;
                }
                _this.$http({
                    url: 'my/goodBtn',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{id:id,token: localStorage.getItem('user_token')}
                }).then(res => {
                    if(res.data.code == 1)
                    {
                        _this.is_good = _this.is_good == 1 ? 0 : 1;
                    }
                    layer.msg(res.data.msg);
                });
            }
        }
    }
</script>

<style scoped>
    .video{padding-bottom: 70px;}
    .video .main{padding-top:45px;background: #fff;}
    .right{width:310px;display: block;}
    .right h3{width:100%;font-size:24px;color:#000;display: block;line-height: 30px;font-weight: normal;}
    .like_list{width:100%;display: block;margin-top:24.4px;}
    .like_list a{width: 100%;}
    .like_list_img{width:128px;min-width:128px;height: 72px;overflow: hidden;border-radius: 5px;display: block;margin-right: 5px;}
    .like_list_img img{width:100%;height: 100%;object-fit: cover;display: block;transition: all ease .5s;}
    .like_list:hover .like_list_img img{transform: scale(1.05);}
    .like_list_text{width:calc(100% - 140px);display: block;}
    .like_list_text h2{width: 100%;display: block;font-size:16px;line-height: 20px;color:#000;font-weight: normal;margin-bottom: 15px;}
    .like_list_text p{width:100%;font-size:12px;line-height: 16px;color:#585858;}
    .like_list_text p span{margin-right: 20px;display: block;margin-bottom: 3px;}

    .left{width:869px;padding-left:37px;display: block;}
    .video_main{width: 832px;height: 512px;display: block;background: #232323;border-radius: 5px;overflow: hidden;position: relative;}
    .video_main video{width: 100%;height: 469px;object-fit: contain;display: block;}
    .video_operate{width: 100%;height: 43px;cursor: pointer;}
    .video_operate p{width:auto;font-size:12px;color:#a7a7a7;line-height: 16px;padding:0 5px 0 15px;}
    .video_operate p img{height: 16px;object-fit: contain;display: block;margin-right: 5px;}
    .video_operate_see{flex-grow: 1;text-align: right;font-size:12px;color:#a7a7a7;display: block;line-height: 16px;padding-right: 15px;}


    .content{width:570px;margin-top:27px;padding-bottom: 22px;}
    .content img{width: 129px;height: 155px;margin-right: 19px;object-fit: cover;display: block;}
    .content_info{width: 422px;display: block;}
    .content_info h2{width:100%;font-size:24px;line-height: 38px;color:#000;display: block;}
    .content_info h3{width:100%;font-size:14px;line-height: 20px;color:#000;font-weight: normal;margin:5px 0 35px;}
    .content_info h3 i{font-weight: bold;white-space: nowrap;display: inline-block;}

    .content_info p{width: 100%;}
    .content_info p span{width: auto;font-size:14px;line-height: 21px;padding:0 10px;color:#000;display: block;border:1px solid #000;border-radius: 16px;margin-right: 16px;margin-bottom: 3px;}


    @media screen and (max-width: 1920px) {
        .web_detail .right{display: none;}
        .web_detail .left{width:100%;margin:0 auto;padding:0 2%;}
        .web_detail.video .main{padding-top: 3.629vw;}
        .video_main{width: 100%;height: auto;}
        .video_main video{height: 56vw;}
        .web_detail .content{width: 100%;margin-top:2.177vw;padding-bottom: 2vw;}
    }
    @media screen and (max-width: 640px) {
        .content img{display: none;}
        .content_info{width: 100%;}
        .content_info h2{font-size:20px;line-height: 30px;}
        .content_info h3{font-size:14px;line-height: 18px;margin:1vw 0;}
        .content_info p span{margin-right: 2vw;border-radius: 5px;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/video/detail.vue